const OTROS = '00'
const FACTURA = '01'
const RECIBO_POR_HONORARIOS = '02'
const BOLETA = '03'
const LIQUIDACION_DE_COMPRAS = '04'
const NOTA_CREDITO = '07'
const NOTA_DEBITO = '08'
const GUIA_REMISION_REMITENTE = '09'
const TICKET_MAQUINA_REGISTRADORA = '12'
const RECIBO_POR_SERVICIOS_PUBLICOS = '14'
const COMPROBANTE_DE_RETENCION = '20'
const GUIA_REMISION_TRANSPORTISTA = '31'
const DOCUMENTO_DEL_OPERADOR = '34'
const SERAFINADO = 'SE'
const CONSUMO = 'CO'

const __dictionary = {
  [OTROS]: {
    id: OTROS,
    nombre: '00 - OTROS/TICKET'
  },
  [FACTURA]: {
    id: FACTURA,
    nombre: '01 - FACTURA'
  },
  [RECIBO_POR_HONORARIOS]: {
    id: RECIBO_POR_HONORARIOS,
    nombre: '02 - RECIBO POR HONORARIOS'
  },
  [BOLETA]: {
    id: BOLETA,
    nombre: '03 - BOLETA'
  },
  [LIQUIDACION_DE_COMPRAS]: {
    id: LIQUIDACION_DE_COMPRAS,
    nombre: '04 - LIQUIDACION DE COMPRAS'
  },
  [NOTA_CREDITO]: {
    id: NOTA_CREDITO,
    nombre: '07 - NOTA CREDITO'
  },
  [NOTA_DEBITO]: {
    id: NOTA_DEBITO,
    nombre: '08 - NOTA DEBITO'
  },
  [GUIA_REMISION_REMITENTE]: {
    id: GUIA_REMISION_REMITENTE,
    nombre: '09 - GUIA REMISION REMITENTE'
  },
  [TICKET_MAQUINA_REGISTRADORA]: {
    id: TICKET_MAQUINA_REGISTRADORA,
    nombre: '12 - TICKET EN MAQUINA REGISTRADORA'
  },
  [RECIBO_POR_SERVICIOS_PUBLICOS]: {
    id: RECIBO_POR_SERVICIOS_PUBLICOS,
    nombre: '14 - RECIBO POR SERVICIOS PUBLICOS DE SUMINISTRO DE ENERGIA ELÉCTRICA, AGUA, TELEFONO, TELEX Y TELEGRÁFICOS Y OTROS'
  },
  [COMPROBANTE_DE_RETENCION]: {
    id: COMPROBANTE_DE_RETENCION,
    nombre: '20 - COMPROBANTE DE RETENCIÓN'
  },
  [GUIA_REMISION_TRANSPORTISTA]: {
    id: GUIA_REMISION_TRANSPORTISTA,
    nombre: '31 - GUIA REMISION TRANSPORTISTA'
  },
  [DOCUMENTO_DEL_OPERADOR]: {
    id: DOCUMENTO_DEL_OPERADOR,
    nombre: '34 - DOCUMENTO DEL OPERADOR'
  },
  [SERAFINADO]: {
    id: SERAFINADO,
    nombre: 'SE - SERAFINADO'
  },
  [CONSUMO]: {
    id: CONSUMO,
    nombre: 'CO - CONSUMO'
  }
}

const __array = [
  __dictionary[FACTURA],
  __dictionary[BOLETA],
  __dictionary[OTROS],
  __dictionary[NOTA_CREDITO],
  __dictionary[NOTA_DEBITO],
  __dictionary[LIQUIDACION_DE_COMPRAS],
  __dictionary[GUIA_REMISION_REMITENTE],
  __dictionary[GUIA_REMISION_TRANSPORTISTA],
  __dictionary[DOCUMENTO_DEL_OPERADOR],
  __dictionary[SERAFINADO],
  __dictionary[CONSUMO]
]

const __ventasArray = [__dictionary[FACTURA], __dictionary[BOLETA], __dictionary[OTROS], __dictionary[NOTA_CREDITO]]
const __comprasArray = [
  __dictionary[OTROS],
  __dictionary[FACTURA],
  __dictionary[BOLETA],
  __dictionary[LIQUIDACION_DE_COMPRAS],
  __dictionary[TICKET_MAQUINA_REGISTRADORA],
  __dictionary[DOCUMENTO_DEL_OPERADOR],
  __dictionary[NOTA_CREDITO],
  __dictionary[NOTA_DEBITO]
]
const __comprasAkdemicArray = [
  __dictionary[OTROS],
  __dictionary[FACTURA],
  __dictionary[RECIBO_POR_HONORARIOS],
  __dictionary[BOLETA],
  __dictionary[LIQUIDACION_DE_COMPRAS],
  __dictionary[TICKET_MAQUINA_REGISTRADORA],
  __dictionary[RECIBO_POR_SERVICIOS_PUBLICOS],
  __dictionary[COMPROBANTE_DE_RETENCION],
  __dictionary[DOCUMENTO_DEL_OPERADOR],
  __dictionary[NOTA_CREDITO],
  __dictionary[NOTA_DEBITO]
]
const __compraOrdenesCompraArray = [__dictionary[OTROS], __dictionary[GUIA_REMISION_REMITENTE]]
const __ingresoAlmacenPorOrdenCompraArray = [__dictionary[OTROS], __dictionary[GUIA_REMISION_REMITENTE]]
const __guiasOrdenArray = [__dictionary[OTROS], __dictionary[GUIA_REMISION_REMITENTE]]
const __guiasOrdenGrifoArray = [__dictionary[OTROS], __dictionary[SERAFINADO], __dictionary[CONSUMO]]
const __inventariosArray = [__dictionary[OTROS], __dictionary[GUIA_REMISION_REMITENTE]]
const __transferenciasArray = [__dictionary[OTROS], __dictionary[GUIA_REMISION_REMITENTE]]
const __darDeBajaArray = [__dictionary[FACTURA], __dictionary[BOLETA], __dictionary[NOTA_CREDITO], __dictionary[GUIA_REMISION_REMITENTE]]
const __emisorArray = [__dictionary[FACTURA], __dictionary[BOLETA], __dictionary[NOTA_CREDITO]]

const __values = [OTROS, FACTURA, BOLETA, LIQUIDACION_DE_COMPRAS, NOTA_CREDITO, NOTA_DEBITO, GUIA_REMISION_REMITENTE, GUIA_REMISION_TRANSPORTISTA, DOCUMENTO_DEL_OPERADOR]

export default Object.freeze({
  OTROS,
  FACTURA,
  BOLETA,
  LIQUIDACION_DE_COMPRAS,
  NOTA_CREDITO,
  NOTA_DEBITO,
  GUIA_REMISION_REMITENTE,
  GUIA_REMISION_TRANSPORTISTA,
  DOCUMENTO_DEL_OPERADOR,
  SERAFINADO,
  CONSUMO,
  __dictionary,
  __array,
  __ventasArray,
  __comprasArray,
  __comprasAkdemicArray,
  __compraOrdenesCompraArray,
  __ingresoAlmacenPorOrdenCompraArray,
  __guiasOrdenArray,
  __guiasOrdenGrifoArray,
  __inventariosArray,
  __values,
  __transferenciasArray,
  __darDeBajaArray,
  __emisorArray
})
